"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _isNil = _interopRequireDefault(require("../../utils/object/isNil"));

var setCanvasTextDirection = function setCanvasTextDirection(context, textDirection) {
  if ((0, _isNil["default"])(context)) return;
  var canvas = context.canvas; // setAttribute may not be available on OffscreenCanvas

  if ('setAttribute' in canvas) {
    // Set attribute when canvas is in the DOM.
    canvas.setAttribute('dir', textDirection);
  } // https://developer.mozilla.org/en-US/docs/Web/API/CanvasRenderingContext2D/direction


  if ('direction' in context) {
    context.direction = textDirection; // This property is experimental.
  }
};

var _default = setCanvasTextDirection;
exports["default"] = _default;